import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { getCookie } from 'typescript-cookie';
import i18n from '../plugins/i18n';
import { BASE_URL } from '../const/environments.constants';
import { ESession } from '../enums/auth.enum';

const getBaseUrl = (): string => BASE_URL || '';

const API = axios.create({
    baseURL: getBaseUrl(),
});

API.interceptors.request.use((req: InternalAxiosRequestConfig) => {
    const token = getCookie(ESession.JWT);
    const isForm = req.data instanceof FormData;

    if (isForm) {
        if (req.headers) delete req.headers['Content-Type'];
    } else if (req.headers && !req.headers['Content-Type']) {
        req.headers['Content-Type'] = 'application/json';
    }

    req.headers['content-language'] = i18n.language || 'es';
    req.headers.utcoffset = '-300';
    if (token && req.headers) req.headers.Authorization = `Bearer ${token}`;
    return req;
});

API.interceptors.response.use(
    (response: AxiosResponse) => response.data,
    (error: AxiosError) => Promise.reject(error.response?.data),
);

export { API, getBaseUrl };
